var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreased({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91863 20.1729L8.33398 20.6835L7.74934 20.1729C2.83292 15.8793 0.333984 12.1303 0.333984 8.83481C0.333984 4.16797 3.97581 0.833496 8.33398 0.833496C12.6922 0.833496 16.334 4.16797 16.334 8.83481C16.334 12.1303 13.835 15.8793 8.91863 20.1729ZM2.11133 8.83464C2.11133 11.3677 4.16165 14.5543 8.33355 18.3148C12.5055 14.5543 14.5558 11.3677 14.5558 8.83464C14.5558 5.18657 11.7432 2.61139 8.33355 2.61139C4.92387 2.61139 2.11133 5.18657 2.11133 8.83464ZM12.7775 8.6924H9.36414V5.2785H7.65747V8.6924H4.24414V10.3993H7.65747V13.8132H9.36414V10.3993H12.7775V8.6924Z",
    fill: "#00A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreased);
export default __webpack_public_path__ + "static/media/increased.c0691922b04f03e3f870db0dff8b59e6.svg";
export { ForwardRef as ReactComponent };